import { render, staticRenderFns } from "./PdfFieldEditor.vue?vue&type=template&id=028c4a6b&scoped=true"
import script from "./PdfFieldEditor.vue?vue&type=script&lang=js"
export * from "./PdfFieldEditor.vue?vue&type=script&lang=js"
import style0 from "./PdfFieldEditor.vue?vue&type=style&index=0&id=028c4a6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028c4a6b",
  null
  
)

export default component.exports